import React from 'react';
import { ShieldCheck, Lock, CheckCircle2 } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react'; // Biblioteca padrão para gerar QR Codes

export default function AssinaturaDigital({ imovelId, hashAutenticidade }) {
  
  // URL que o QR Code vai abrir (Aponte para o domínio onde sua página de validação estará)
  const urlValidacao = `https://seusistema.pro/validar?id=${imovelId}&auth=${hashAutenticidade}`;

  return (
    <div className="mt-12 border-4 border-slate-900 p-8 rounded-[3rem] bg-white shadow-2xl flex flex-col md:flex-row items-center gap-8 break-inside-avoid">
      
      {/* QR CODE REAL */}
      <div className="bg-white p-4 rounded-2xl border-2 border-slate-100 shadow-inner flex flex-col items-center">
        <QRCodeSVG 
          value={urlValidacao} 
          size={120} 
          level="H" // Alta correção de erro para funcionar mesmo se o papel estiver amassado
          includeMargin={true}
        />
        <p className="text-[7px] font-black text-slate-400 mt-2 uppercase tracking-tighter">Autenticidade Garantida</p>
      </div>
      
      {/* TEXTO DE CERTIFICAÇÃO */}
      <div className="flex-1 space-y-3">
        <div className="flex items-center gap-2 text-emerald-600">
          <ShieldCheck className="w-6 h-6" />
          <h4 className="font-black text-sm uppercase tracking-tighter italic">Selo de Integridade Digital NBR 14653</h4>
        </div>
        
        <p className="text-[10px] text-slate-500 leading-relaxed text-justify">
          Este Laudo de Avaliação foi encerrado e assinado digitalmente pelo sistema <strong>Engenharia de Avaliações .PRO</strong>. 
          A tecnologia de <em>Hashing</em> empregada garante que qualquer alteração nos valores, áreas ou fotos após a data de 
          emissão invalidará este certificado. O QR Code ao lado permite a conferência imediata dos dados originais na base de dados do emissor.
        </p>

        <div className="flex flex-wrap gap-2">
          <div className="bg-slate-100 px-3 py-1 rounded-full text-[9px] font-mono font-bold text-slate-600 border border-slate-200">
            HASH: {hashAutenticidade}
          </div>
          <div className="bg-blue-50 px-3 py-1 rounded-full text-[9px] font-bold text-blue-600 border border-blue-100 flex items-center gap-1">
            <CheckCircle2 className="w-3 h-3" /> VERIFICADO EM SISTEMA
          </div>
        </div>
      </div>

      {/* STATUS DE BLOQUEIO */}
      <div className="flex flex-col items-center justify-center border-l border-slate-100 pl-8 min-w-[100px]">
        <Lock className="w-8 h-8 text-slate-900 mb-2" />
        <span className="text-[9px] font-black text-slate-900 uppercase">DOCUMENTO</span>
        <span className="text-[9px] font-black text-red-600 uppercase">IMUTÁVEL</span>
      </div>
    </div>
  );
}